// extracted by mini-css-extract-plugin
export default {"empty":"empty-state_empty__X2NyW","emptyIcon":"empty-state_emptyIcon__u-Wg1","emptyTitle":"empty-state_emptyTitle__Rbrrp","emptySubtitle":"empty-state_emptySubtitle__ETM9r"};